import ValidationError from '/shared/errors/ValidationError';
import { toNormaliseErrorInput } from '/shared/functions/normaliseError';
import type { Dispatch, GetState } from '/business/shared/state/actions/types';
import { errorWithContext } from '/business/shared/state/actions/types';

const setActiveApplication =
  (id: string | number | null = null) =>
  async (dispatch: Dispatch, getState: GetState) => {
    try {
      const { applications } = getState();
      const parsedId = typeof id === 'number' ? id : Number.parseInt(id || '', 10);
      const cachedApp = (applications?.items || []).find((item) => item.id === parsedId);

      const cachedBasket =
        cachedApp && cachedApp.basketItems
          ? {
              items: cachedApp.basketItems,
              meta: cachedApp.basketMeta,
              questionAnswerStructured: cachedApp.questionAnswerStructured,
            }
          : null;

      dispatch({ type: 'SET_APPLICATION_ACTIVE_FULFILLED', applicationId: id, cachedBasket });
      return id;
    } catch (error) {
      if (error instanceof ValidationError) {
        dispatch({ type: 'SET_APPLICATION_ACTIVE_REJECTED', error });
      } else {
        dispatch({
          type: 'SET_APPLICATION_ACTIVE_REJECTED',
          error: errorWithContext(toNormaliseErrorInput(error), 'SET_ACTIVE_APPLICATION'),
        });
      }
      throw error;
    }
  };

export default setActiveApplication;
